module.exports = [{
      plugin: require('/Users/muhammadmateen/Desktop/work/onechange/1Change-App/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
